import ContentState    from '../State/ContentState';
import SavingState     from '../State/SavingState';
import CollectionState from '../State/CollectionState';
import SectionState    from '../State/SectionState';

/**
 * @description Controllers may extend this Core controller
 * allowing access to dynamic content.
 *
 * @author rsommerfeld <roni.s.sommerfeld@altice.pt>
 *
 * @since 7.0.0
 *
 * @class Controller
 */
export default class Controller {
  /**
   * Content State
   *
   * @deprecated
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {ContentState}
   */
  content_state = new ContentState();

  /**
   * Section State
   *
   * Defines the loading/error state of a section
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {SectionState}
   */
  section_state = new SectionState();

  /**
   * Saving State
   *
   * Defines the saving state of a given action
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {SavingState}
   */
  saving_state = new SavingState();

  /**
   * Collection State
   *
   * Defines the state of a collection
   *
   * @public
   *
   * @type {CollectionState}
   *
   * @since 7.0.0
   */
  collection_state = new CollectionState();
}